import React from 'react';
import { ThemeProvider } from '@material-ui/core';
import { HelmetProvider } from 'react-helmet-async';
import { theme } from './styles'
import appStore from "./stores";
import { Provider } from 'react-redux';
import AppRouter from './AppRouter';
import { Alerts, LinearLoader, AppPromoDialog, PremiumOfferDialog } from './components';
import './App.scss';

const App = (props: any): JSX.Element => {
  return (
    <HelmetProvider>
      <Provider store={appStore}>
        <ThemeProvider theme={theme}>
          <LinearLoader />
          <Alerts />
          <AppPromoDialog />
          <PremiumOfferDialog />
          <AppRouter />
        </ThemeProvider>
      </Provider>
    </HelmetProvider>
  );
}
export default App;
